import { render, staticRenderFns } from "./RefPriorityListAddNew.vue?vue&type=template&id=96c73a8c"
import script from "./RefPriorityListAddNew.vue?vue&type=script&lang=js"
export * from "./RefPriorityListAddNew.vue?vue&type=script&lang=js"
import style0 from "./RefPriorityListAddNew.vue?vue&type=style&index=0&id=96c73a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports